import React, { useEffect, useState } from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import Image from "../base/staticImage";
import Accordion from "./accordian";
import NavigationCard from "./navigationCard";
import SubNavigationItem from "./subNavigationItem";
import { getUrlWithCosmosCampaignParams } from "../../utilities/businessLogic";
import TopBarIcons from "../icons/topBarIcons";

import Button from "../base/starButton";
// import Button from "../base/button";

const MobileNavigation = ({ isDonationHeader, campaignToDonationLink, cosmosCampaignId, urlParams }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuSticky, setMenuSticky] = useState(false);
  const [scrollPos, setScrollPos] = useState(0);

  useEffect(() => {
    lockBody(menuOpen);
  }, [menuOpen]);

  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            header {
              logo {
                logoImage
                title
                url
              }
              topBar {
                icon
                text
                url
              }
            }
          }
        }
        contentfulNavigation {
          title
          donationSlug
          navigationItems {
            title
            navigationCard {
              icon
              title
              copy
              link
            }
            subNavigations {
              title
              url
              subNavigationItems {
                title
                url
              }
            }
          }
        }
      }
    `
  );

  const { topBar, logo } = data.site.siteMetadata.header;
  const topBarLinks = topBar.map((item, index) => {
    return item.url ? (
      <li key={"top-bar-link-wrap_" + index}>
        <a href={item.url} className={item.icon} title={item.icon}>
          <TopBarIcons name={item.icon} />
          {item.text}
        </a>
      </li>
    ) : (
      <li key={"top-bar-link-wrap_" + index}>
        <TopBarIcons name={item.icon} />
        {item.text}
      </li>
    );
  });

  const scrollBar = () => {
    if (typeof window !== "undefined") {
      let prevScrollpos = window.pageYOffset;
      window.onscroll = function (event) {
        const maxScroll = document.body.clientHeight - window.innerHeight;
        let currentScrollPos = window.pageYOffset;
        if (
          (maxScroll > 0 && prevScrollpos > currentScrollPos && prevScrollpos <= maxScroll) ||
          (maxScroll <= 0 && prevScrollpos > currentScrollPos) ||
          (prevScrollpos <= 0 && currentScrollPos <= 0)
        ) {
          if (!menuSticky) setMenuSticky(!menuSticky);
        } else {
          if (menuSticky) setMenuSticky(!menuSticky);
        }
        prevScrollpos = currentScrollPos;
      };
    }
  };

  const lockBody = (menuOpen) => {
    document.body.classList[menuOpen ? "add" : "remove"]("menu-open");
  };

  const handleMenuToggle = () => {
    setScrollPos(window.scrollY);
    setMenuOpen(!menuOpen);

    if (menuOpen) {
      window.scrollTo(0, scrollPos);
    }
  };

  scrollBar();
  // menusticky={menuSticky.toString()} MenuBar
  // menuOpen={menuOpen.toString()} MenuLinks (deprecated, so removed because implemented using css)
  return (
    <div className={`header header--mobile${menuSticky ? " sticky" : ""}`}>
      <div className={`navbar`}>
        <Link to={logo.url} className={"logo" + (isDonationHeader ? " disable-link" : "")} title={logo.title}>
          <Image src={logo.logoImage} />
        </Link>
        <nav className={isDonationHeader ? "hide" : "navi-wrapper"}>
          <ul className={`navigation${menuOpen ? " active-menu" : ""}`}>
            <Accordion>
              {data.contentfulNavigation.navigationItems.map((navItem, i) =>
                i === 0 ? (
                  <li label={navItem.title} key={"navigation-items-title-wrap_" + i} isOpen>
                    <ul className="navigation--item__subnavigation">
                      <div className="scroll-area">
                        {SubNavigationItem(navItem.subNavigations)}
                        {navItem.navigationCard && NavigationCard(navItem.navigationCard)}
                      </div>
                    </ul>
                  </li>
                ) : (
                  <li label={navItem.title} key={"navigation-items-title-wrap_" + i}>
                    <ul className="navigation--item__subnavigation">
                      <div className="scroll-area">
                        {SubNavigationItem(navItem.subNavigations)}
                        {navItem.navigationCard && NavigationCard(navItem.navigationCard)}
                      </div>
                    </ul>
                  </li>
                )
              )}
            </Accordion>
            <div className={isDonationHeader ? "hide" : "wrapper mobile_wrapper"}>
              <div className="mobile_sb_wrapper">{topBarLinks}</div>
            </div>
          </ul>

          <Button
            href={getUrlWithCosmosCampaignParams(campaignToDonationLink ?? data.contentfulNavigation.donationSlug, urlParams, cosmosCampaignId)}
            type="btn-donation"
            text="Donate"
          />
          <button
            menuopen={menuOpen.toString()}
            onClick={handleMenuToggle}
            aria-haspopup="true"
            aria-controls="hamburger-menu"
            className={`mobile-menu ${menuOpen ? "active" : ""}`}
          >
            <span className="sr-only">mobile menu toggle</span>
            <span></span>
          </button>
        </nav>
      </div>
    </div>
  );
};

export default MobileNavigation;
